import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class EspressoIcon extends AbstractIcon {
  static selector = "espresso-icon"

  getHTML() {
    return `<svg
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64"
        xml:space="preserve">
        <path style="stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="M49,31
          c-0.448,2.818,4.865,2.276,6.554-2.446c2.87-8.022-6.033-9.685-7.554-4.581c-1.564,5.247-4.366,9.667-6.204,13.615
          c0,0,15.204,2.673,15.204,8.912c0,4.505-11.641,7.5-26,7.5S5,51.924,5,46.5c0-7.804,35-8.163,35-2.5c0,1.657-4.029,3-9,3
          s-9-1.343-9-3c0-7-9-15.085-9-27.085c0-7.657,34.99-7.973,35-0.085c0.007,5.295-24.104,7.251-29.364,2.376
          c-2.473-2.292,3.53-4.644,11.596-4.445c5.339,0.132,9.274,0.698,9.319,2.028c0.045,1.334-5.432,1.954-12.017,1.492"/>
        </svg>`;
  }
}

componentsRegistryService.define(EspressoIcon);